<template>
	<div>
		<i-head-top></i-head-top>
		
		<div class="h-banner-box" id="h-banner">
			<div class="container fc-bet">
				<router-link to="index" class="logo fc">
					<img src="../assets/logo-shop.png" alt="" srcset="" width="184">
				</router-link>
				<div class="search">
					<div class="search-text flex">
						<input type="text" class="search-ipt" placeholder="输入关键字">
						<a href="" class="search-top-btn fcc">
							<img src="../assets/search-btn.png" alt="">
						</a>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'login-after-head-search',
		data() {

			return {
				
			}
		},
		methods: {
			 
		},
		mounted() {
			
		}

	}
</script>
<style scoped>
	.h-banner-box .search-ipt{
		width: 338px;
	}
	.h-banner-box .search{
		margin-right: 0;
	}
</style>

